import type { FaireProductEntity } from "../../entity_types/product";

export const p_epf268mxjw: FaireProductEntity = {
  token: "p_epf268mxjw",
  type: "product",
  name: "Bee Clean Organic Beeswax Hand Sanitizer-13 Lavender 4 packs",
  brandToken: "b_zkxn3dn2pw",
  brandName: "Bee Clean",
  imageUrl:
    "https://cdn.faire.com/fastly/a403f0ba461cca8185b1338c20fdb1a0002001c743e63974af119845cd0b49f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/486f0a68622c19bc7f884297046ff2a529c6704a8184b778b6b1389b0caddd24.jpeg",
    "https://cdn.faire.com/fastly/c7731f6d7d20c76cae2a5bb26dcc9145a0f35d3e606aef6bef98da6093bafdd5.png",
    "https://cdn.faire.com/fastly/d9d8f5e73500457ba263599aa2b8a7b26868190353ac973f74156c5243aff4f8.jpeg",
    "https://cdn.faire.com/fastly/e1a840f5d973d526dd0535bb2c2f09dba61d3869ea5f57f6d84704fb7a2b5c7f.jpeg",
    "https://cdn.faire.com/fastly/d3b5ce0ec621e2fb6113070e2eeb29fa4d99a4a21833825136a3c95031386efe.jpeg",
    "https://cdn.faire.com/fastly/45102f113e88f747561577eb04fb6b3ee4db9e71b2513772874098ab55c0e371.jpeg",
    "https://cdn.faire.com/fastly/6a569f727fd09eb95a1f60ff4428671ffd8c94dc7a9301096b71a1feae419751.jpeg",
    "https://cdn.faire.com/fastly/087fc64d3e5d7a9422f5e6c2dc5f75161afdb542057f15094455463c969e7254.jpeg",
    "https://cdn.faire.com/fastly/02c311e0a519da1c0a7fb8c988a08aae61a989bc2c5ba3b409ec2d2d506df68b.jpeg",
    "https://cdn.faire.com/fastly/e615e1e54e7827f00b8af9a4e807a2c210df883cb7ee3962132efb9e07deb36e.jpeg",
    "https://cdn.faire.com/fastly/8f1eeeae76f20c3dd1e5daf8b022cb085aea66a49c3bd813df8c84a0c8080c50.jpeg",
    "https://cdn.faire.com/fastly/947e4679da872ebf0101f2398649fb6726c7418926579b899ac7e05f54cfee00.jpeg",
    "https://cdn.faire.com/fastly/2258c433e77f34ca4aa71c20acbde36e5a803a0e8358f2e0d27e4041c42aa46c.jpeg",
    "https://cdn.faire.com/fastly/7b0ac5ace2a0365ee8f97b335214d034a6929becf2ca18351d563921a3fedb5d.jpeg",
    "https://cdn.faire.com/fastly/aee31df51085f9e6ba0bc0c0d1057a1113cb72d2c114bf5a7b54fdcac0da9e43.jpeg",
    "https://cdn.faire.com/fastly/bb46fad8d90562bbbfaeb01cc85ede2c276f354b69ede9601b00f4e85c91c249.jpeg",
    "https://cdn.faire.com/fastly/01b2c56c3cb4f3197bced7643c2c86e0cd75c528a6700f81a488d573fcfca51a.jpeg",
    "https://cdn.faire.com/fastly/4c2168a4f2ba5700c9b0e2856a6f10e410dcde026b648c103062967028252dca.png",
    "https://cdn.faire.com/fastly/341ad75342bed061165e538f3c887f89abc971a4ab3eaf093a37a4b912bb8c3c.png",
  ],
  priceDollars: 15.24,
  description:
    "Bee Clean Beeswax Hand Sanitizers help you stay healthy and humming by killing germs with kinder, 100% organic and natural ingredients. Our spray-on mist is mess free via our convenient, innovative, recyclable packaging. Bee Clean contains natural antimicrobial peptides and organic ethyl alcohol to kill 99.9% of germs. It moisturizes using beeswax, vitamin E, avocado oil and apricot seed oil so hands feel soft and dry with no sticky residue. Our refreshing citrus peppermint and lavender essential scents are light and revitalizing. Bee Clean is proudly made in the USA and a NM True Certified product. These 13 lavender scent 4 packs are a great impulse item to place at your cash register (for a total of 52 lavender units).",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:55.718Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
